import Filters from "../filters/_Filter";

import React from "react";
import * as ReactDOM from "react-dom/client";

export function calendarFilter(setCategoriesList) {
    const filtersContainer = document.querySelector(".wpContent--webcastFilters");
    const filtersRoot = ReactDOM.createRoot(filtersContainer);

    filtersRoot.render(<Filters showTags={false} haveCalendar={true} startOpen={filtersContainer.classList.contains("open")} setCategoriesList={setCategoriesList} />);
}
